export const OTP_CHANNELS = ["EMAIL", "SMS"];
export const DEFAULT_OTP_CHANNEL = "EMAIL";

/**
 * Canal do código de confirmação de cadastro configurado para o tenant
 * (CONFIGS.OTP_CHANNEL). Qualquer valor ausente ou desconhecido vira EMAIL.
 * @param {object} config - Configuração do tenant (tenantConfig)
 * @returns {'EMAIL' | 'SMS'}
 */
export const resolveOtpChannel = (config) => {
  const channel = config?.CONFIGS?.OTP_CHANNEL;
  if (typeof channel !== "string") {
    return DEFAULT_OTP_CHANNEL;
  }

  const normalized = channel.trim().toUpperCase();
  return OTP_CHANNELS.includes(normalized) ? normalized : DEFAULT_OTP_CHANNEL;
};

/**
 * Meio pelo qual o Cognito entregou o código (codeDeliveryDetails.deliveryMedium).
 * Aceita tanto o formato { value: 'SMS' } quanto a string 'SMS'.
 * @param {object} codeDeliveryDetails
 * @returns {'EMAIL' | 'SMS' | null}
 */
export const getDeliveryMedium = (codeDeliveryDetails) => {
  const medium =
    codeDeliveryDetails?.deliveryMedium?.value ??
    codeDeliveryDetails?.deliveryMedium;
  if (typeof medium !== "string") {
    return null;
  }

  const normalized = medium.toUpperCase();
  return OTP_CHANNELS.includes(normalized) ? normalized : null;
};
